const accessBg = (() => {
  const pageAccess = (document.getElementById("pageAccess") != null);
  if (pageAccess) {


    let sW = window.innerWidth;


    // if(sW > 750){

    ScrollTrigger.create({
      trigger: "#jsSecComCntBg",
      pin: "#jsSecComCntBg .js-cnt-bg-wrap",
      // markers: true,
      start: "top top",
      endTrigger: "#jsSecComCntBg",
      end: "bottom bottom",
      position: "fixed"
    });

    ScrollTrigger.create({
      trigger: "#jsSecComCntBg .js-sec-car",
      // markers: true,
      start: "top center",
      toggleClass: { targets: "#jsSecComCntBg .js-cnt-bg-wrap", className: "car" },
    })
    ScrollTrigger.create({
      trigger: "#jsSecComCntBg .js-sec-golf",
      // markers: true,
      start: "top center",
      endTrigger: "body",
      end: "bottom top",
      toggleClass: { targets: "#jsSecComCntBg .js-cnt-bg-wrap", className: "golf" },
    })

    // }



  }
})();
export default accessBg;